'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPawOutline = function IoIosPawOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.7 15.3c0.5 1.3 0.4 3-0.2 4.5-0.8 1.9-2.5 3.3-4 3.3-0.4 0-0.8-0.1-1.2-0.2-1.7-0.8-2.3-3.5-1.3-6.2 0.8-2.2 2.4-3.6 4-3.6 0.3 0 0.7 0.1 1 0.3 0.8 0.3 1.4 1 1.7 1.9z m-1.4 3.9c0.5-1.2 0.5-2.4 0.1-3.4-0.1-0.4-0.4-1-0.9-1.2-0.2-0.1-0.3-0.1-0.5-0.1-1.1 0-2.2 1.1-2.9 2.8-0.7 1.9-0.4 3.9 0.7 4.3 0.1 0.1 0.4 0.1 0.6 0.1 1.1 0 2.3-1 2.9-2.5z m-21.3-2.5c1 2.7 0.4 5.4-1.3 6.2-0.4 0.1-0.8 0.2-1.2 0.2-1.5 0-3.2-1.4-4-3.3-0.6-1.5-0.7-3.2-0.2-4.5 0.3-0.9 0.9-1.6 1.7-1.9 0.3-0.2 0.7-0.3 1-0.3 1.6 0 3.3 1.4 4 3.6z m-1.8 4.9c1.1-0.4 1.4-2.4 0.7-4.3-0.7-1.7-1.8-2.8-2.9-2.8-0.2 0-0.3 0-0.5 0.1-0.5 0.2-0.8 0.8-0.9 1.2-0.4 1-0.4 2.2 0.1 3.4 0.6 1.5 1.8 2.5 2.9 2.5 0.2 0 0.5 0 0.6-0.1z m5.3-5.1c-2.2-0.1-4.1-2.5-4.4-5.4-0.2-1.8 0.3-3.5 1.2-4.7 0.7-0.8 1.5-1.3 2.5-1.4h0.4c2.1 0.1 3.6 2.3 3.9 5.2 0.3 1.9 0 3.8-1 5-0.6 0.7-1.3 1.1-2.2 1.2-0.1 0-0.3 0.1-0.4 0.1z m-2.1-9.3c-0.8 0.9-1.1 2.3-1 3.7 0.3 2.3 1.7 4.2 3.1 4.3h0.3c0.5-0.1 0.9-0.4 1.3-0.8 0.8-1 0.9-2.4 0.8-4-0.2-2.3-1.3-4.1-2.7-4.1h-0.3c-0.7 0-1.2 0.5-1.5 0.9z m6.6 11.6c5 0 10 5.9 10 11.6 0 1.7-0.9 3.1-1.7 3.7-1 0.7-1.8 0.9-3.3 0.9-1.8 0-2.3-0.6-3.1-1.2-0.6-0.4-1.1-0.8-1.9-0.8s-1.2 0.4-1.9 0.8c-0.8 0.6-1.3 1.2-3.1 1.2-1.5 0-2.3-0.2-3.3-0.9-0.8-0.6-1.7-2-1.7-3.7 0-5.7 5-11.6 10-11.6z m7.7 14.1c0.4-0.3 1.1-1.3 1.1-2.5 0-2.4-1.1-5-2.9-7.1-0.8-1-1.8-1.9-2.8-2.4-1-0.7-2.1-0.9-3.1-0.9s-2.1 0.2-3.1 0.9c-1 0.5-2 1.4-2.8 2.4-1.8 2.1-2.9 4.7-2.9 7.1 0 1.2 0.7 2.2 1.1 2.5 0.9 0.5 1.4 0.8 2.7 0.8 1.1 0 1.5-0.3 2-0.7 0.2-0.1 0.3-0.3 0.5-0.3 0.7-0.5 1.4-1 2.5-1s1.8 0.5 2.5 1c0.2 0 0.3 0.2 0.5 0.3 0.5 0.4 0.9 0.7 2 0.7 1.2 0 1.8-0.3 2.7-0.8z m-3.6-16.5c-0.9-0.1-1.6-0.5-2.2-1.2-1-1.2-1.3-3.1-1-5 0.3-2.9 1.8-5.1 3.9-5.2h0.5c0.9 0.1 1.7 0.6 2.4 1.4 0.9 1.2 1.4 2.9 1.2 4.7-0.3 2.9-2.2 5.2-4.4 5.3h-0.4z m-2-6c-0.1 1.6 0 3 0.8 4 0.4 0.4 0.9 0.7 1.3 0.8h0.3c1.4-0.1 2.9-2 3.2-4.3 0.1-1.4-0.3-2.8-1.1-3.7-0.3-0.4-0.7-0.9-1.4-1h-0.4c-1.4 0.1-2.5 1.9-2.7 4.2z' })
        )
    );
};

exports.default = IoIosPawOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-paw-outline.js
// module id = 2262
// module chunks = 0